import {Injectable} from '@angular/core';
/**
 * Created by LifeSoft on 27/10/17.
 */
@Injectable()
export class LoginUserBody {
  public username: string;
  public password: string;
}
